{
  "version": "solve-1",
  "form": "solveMs = exp(a + b*ln(simMs) + c*ln(size))",
  "fittedOn": "2026-08-01",
  "sim": {
    "a": 2.3836,
    "b": 0.3646,
    "c": 2.2627
  },
  "cheap": {
    "a": 4.0297,
    "b": 0.3422,
    "c": 1.5191
  },
  "fit": {
    "puzzles": 205,
    "minPlayers": 3,
    "traces": 24,
    "sizes": [
      7,
      11
    ],
    "cvMedianPctErr": 0.2287,
    "cheapCvMedianPctErr": 0.2053
  }
}
